import { useApi, useToast, useWorkspace } from '~/contexts';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PageLoader } from '~/routes/public/pages';

export default function BambooRedirect() {
  const api = useApi();
  const location = useLocation();
  const { navigateWorkspace } = useWorkspace();
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const { workspaceId } = new URLSearchParams(location.search).get('state');

      const workspace = await api.www.workspaces(workspaceId).get();

      try {
        await api.bamboohr.postRedirectUri({
          uri: window.location.href,
        });
        toast.success('Successfully connected with Bamboo HR');
        await navigateWorkspace(workspace.key, '/settings/integrations/bamboohr');
      } catch (error) {
        toast.error(error.message);
        await navigateWorkspace(workspace.key, '/settings/integrations');
      }
    })();
  }, [location.search, api, navigateWorkspace, toast, history]);

  return <PageLoader />;
}
